import { TableBody, TableCell, TableRow, Typography } from '@mui/material'
import UsersTableRow from './UsersTableRow'
import shared from '@/components/Settings/settingsShared.module.scss'

export default function UsersTableBody({ rows, openMenu, menuUserId, onOpenMenu }) {
  if (rows.length === 0) {
    return (
      <TableBody>
        <TableRow className={shared.tableRowEmptyCells}>
          <TableCell colSpan={6} className={shared.tdEmpty}>
            <Typography variant="body2" color="text.secondary">
              No users match your search.
            </Typography>
          </TableCell>
        </TableRow>
      </TableBody>
    )
  }
  return (
    <TableBody>
      {rows.map((row, rowIndex) => (
        <UsersTableRow
          key={row.id}
          row={row}
          isLast={rowIndex === rows.length - 1}
          openMenu={openMenu}
          menuUserId={menuUserId}
          onOpenMenu={onOpenMenu}
        />
      ))}
    </TableBody>
  )
}
